<!-- <div class="loading-shade" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
</div> -->

<div>
    <app-aluno-portal></app-aluno-portal>
</div>

<div *ngIf="isAluno">

    <div> <!-- bloco azul financeiro -->
        <mat-card class="div-bloco-financeiro" (click)="mudarPainelFinanceiro(0)">
            <p class="titulo-bloco-financeiro">
                Financeiro
            </p>
        </mat-card>
    </div>

    <div class="div-financeiro" *ngIf="telaFinanceiro == 0"> <!-- Primeira tela: Opções do finaneiro -->
        <mat-card class="card-financeiro">
            <div class="grid-lista-video">
                <mat-list appearance="outline">
                    <mat-list-item class="lista-materias" (click)="mudarPainelFinanceiro(1)"> Painel de Pagamento
                        <mat-icon class="icone-materias">arrow_forward_ios</mat-icon>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item class="lista-materias" (click)="mudarPainelFinanceiro(2)"> Demonstrativo
                        <mat-icon class="icone-materias">arrow_forward_ios</mat-icon>
                    </mat-list-item>
                </mat-list>
            </div>
        </mat-card>
    </div>

    <div *ngIf="telaFinanceiro == 1"> <!-- Segunda Tela: Pagamentos -->
        <mat-card class="card-financeiro">
            <div *ngIf="existePendenciaFinanceira == true">
                <ng-container *ngFor="let fin of financeiroCadastrado.pagamento" style="margin: 0.5%;">
                    <mat-card class="card-parcelas"
                        *ngIf="fin.tipoSituacao == 2 && fin.valor != 0 || fin.tipoSituacao == 4 || fin.tipoSituacao == 5 || fin.tipoSituacao == 6 ">
                        <div>
                            <p class="p-parcela">
                                {{ fin.descricao }}
                            </p>

                            <p class="p-vencimento" *ngIf="fin.tipoSituacao != 6">
                                Vencimento em: {{ fin.dataVencimento | date:'dd/MM/yyyy' }}
                            </p>

                            <p class="p-situacao"
                                [ngClass]="fin.tipoSituacao == 1 ? 'green' : fin.tipoSituacao == 2 ? 'green' : fin.tipoSituacao == 3 ? 'green' : fin.tipoSituacao == 4 ? 'red' : fin.tipoSituacao == 5 ? 'red' : fin.tipoSituacao == 6 ? 'orange' : '-'">
                                {{ fin.tipoSituacao == 1 ? 'Pago' : fin.tipoSituacao == 2 ? 'À vencer' :
                                fin.tipoSituacao == 3 ? 'Isento' : fin.tipoSituacao == 4 ? 'Inadimplente' :
                                fin.tipoSituacao == 5 ? 'Inadimplente Bloqueado' : fin.tipoSituacao == 6 ? 'Residual' :
                                '-' }}
                            </p>
                            <p class="p-valor">
                                Valor: {{ fin.tipoSituacao == 1 ? (fin.valorPago | currency) : fin.tipoSituacao == 2 ?
                                (fin.valorVencimento | currency) : fin.tipoSituacao == 3 ? (fin.valor | currency) :
                                fin.tipoSituacao == 4 ? (fin.valor | currency) : fin.tipoSituacao == 5 ? (fin.valor |
                                currency) : fin.tipoSituacao == 6 ? (fin.valor | currency) : '-' }}
                                <!-- Valor: {{ fin.valor | currency:'R$' }} -->
                            </p>

                            <div>

                                <button mat-raised-button class="botao-pagar" (click)="pagarViaCartao(fin, true)">
                                    <p class="p-botao-pagar1">Pagar com</p>
                                    <p class="p-botao-pagar2">Cartão</p>
                                </button>

                                <button mat-raised-button class="botao-pagar" (click)="pagarViaPix(fin)">
                                    <p class="p-botao-pagar1">Pagar via</p>
                                    <p class="p-botao-pagar2">Pix (TEF)</p>
                                </button>

                                <!-- <button mat-raised-button class="botao-pagar" (click)="enviarBoletoPorEmailOuRecalcular(2, fin, true)" *ngIf="fin.tipoSituacao != 5">
                                    <p class="p-botao-pagar1">Pagar com</p>
                                    <p class="p-botao-pagar2">Boleto</p>
                                </button> -->

                                <button mat-raised-button class="botao-pagar" (click)="goToBoletoDigital(fin)"
                                    *ngIf="fin.tipoSituacao != 5">
                                    <p class="p-botao-pagar1">Pagar com</p>
                                    <p class="p-botao-pagar2">Boleto</p>
                                </button>

                                <div *ngIf="fin.tipoSituacao == 5">
                                    <br />
                                </div>

                                <div class="div-card-ligue" *ngIf="fin.tipoSituacao == 5">
                                    <p class="p-ligue"><strong>Para Pagar Via Boleto</strong></p>
                                    <p class="p-ligue" style="margin-bottom: 10px;"><strong>Ligue na Secretaria da
                                            Escola</strong></p>
                                </div>

                            </div>
                        </div>
                    </mat-card>
                </ng-container>
            </div>

            <mat-card class="card-parcelas" *ngIf="existePendenciaFinanceira == false">
                <p class="p-pendencias">
                    Não Existem Pendências Financeiras
                </p>

                <button mat-raised-button class="botao-pendencias" (click)="mudarPainelFinanceiro(0)">
                    <p class="p-botao-pagar1">OK</p>
                </button>
            </mat-card>
        </mat-card>
    </div>

    <div *ngIf="telaFinanceiro == 2"> <!-- Terceira Tela: Demonstrativo -->
        <mat-card class="card-financeiro">
            <app-matricula-painel-pagamento [financeiroCadastrado]="financeiroCadastrado" (onEfetuadoAcao)="ngOnInit()"
                (loadingGerando)="loadingGerando($event)"></app-matricula-painel-pagamento>
        </mat-card>
    </div>

</div>

<!-- Usar como referencia -->

<div class="body" *ngIf="!isAluno">
    <!-- <mat-card class="mat-elevation-z8 noshadow card-principal" *ngIf="!error;else errorTemplate"> -->
    <mat-card class="mat-elevation-z8 noshadow card-principal">
        <mat-card-title></mat-card-title>
        <mat-card-content>

            <div class="loading-shade" *ngIf="gerando">
                <mat-spinner></mat-spinner>
            </div>
            <div class="content" *ngIf="!isLoadingResults">
                <ng-container *ngIf="!isAluno">
                    <div class="flex form-registro">
                        <div class="align-center">
                            <mat-chip-list>
                                <mat-chip color="primary" selected>Início {{ inicioContrato | datePtBr }}</mat-chip>
                                <mat-chip color="accent" selected>Término {{ terminoContrato | datePtBr }}</mat-chip>

                                <mat-chip color="warn" selected style="height: 25px !important; width: 320px;">
                                    Promessa de pagamento
                                    <input matInput [matDatepicker]="picker" style="width: 90px; margin-top: 3px;"
                                        [(ngModel)]="promessaPagamento">
                                    <mat-datepicker-toggle matSuffix [for]="picker"
                                        style="color:white;"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-chip>
                                <!-- <mat-form-field> -->

                                <!-- </mat-form-field> -->
                                <button *ngIf="promessaPagamento" (click)="openModal()" mat-raised-button
                                    matTooltip="Clique aqui para salvar a data da promessa de pagamento"
                                    class="mat-primary mat-raised-button">
                                    <mat-icon>check</mat-icon>
                                </button>
                            </mat-chip-list>

                        </div>

                        <div class="flex-fill"></div>

                        <div class="flex-end align-center">
                            <div class="flex flex-row">
                                <div>
                                    <button mat-button type="button" (click)="gerarContrato()"
                                        [disabled]="!hasMatricula" color="primary">Gerar Contrato
                                        &nbsp;<mat-icon>note_add</mat-icon></button>
                                </div>
                                <div class="flex flex-column">
                                    <button mat-button type="button" (click)="contrato.click()"
                                        [disabled]="!hasMatricula" color="primary">Upload de Contrato Assinado
                                        &nbsp;<mat-icon>cloud_upload</mat-icon></button>
                                    <span *ngIf="existePendenciaContrato" class="center red">Nenhum contrato
                                        anexado.</span>
                                </div>
                                <div>
                                    <button mat-button type="button" (click)="downloadContrato()"
                                        [disabled]="existePendenciaContrato" color="primary">Download Contrato
                                        &nbsp;<mat-icon>arrow_downward</mat-icon></button>
                                </div>
                                <div>
                                    <button mat-button type="button" (click)="imprimirContrato()"
                                        [disabled]="existePendenciaContrato" color="primary">Visualizar Contrato
                                        &nbsp;<mat-icon>aspect_ratio</mat-icon></button>
                                </div>
                                <div>
                                    <button id="botaopagar" mat-button type="button" color="warn"
                                        (click)="openDetalheCancelamento()">
                                        <span>Cancelamento</span>
                                    </button>
                                </div>
                                <div>
                                    <button mat-button type="button" color="primary"
                                        (click)="openMudancaPlano()" *ngIf="!isAluno && hasMatricula">
                                        <span>Mudar Plano</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div>
                            <title-line title="Forma de Pagamento"></title-line>
                            <app-matricula-formas-pagamento
                                (onChangeTipoPagamento)="onChangeTipoPagamento($event)"></app-matricula-formas-pagamento>
                        </div>

                        <title-line title=""></title-line>
                        <form [formGroup]="form" class="mt-1">
                            <div class="grid grid--auto-fill">
                                <mat-form-field>
                                    <mat-label>Bolsa/Convênio Cod</mat-label>
                                    <mat-select formControlName="campanha">
                                        <mat-option [value]="null"> - </mat-option>
                                        <mat-option *ngFor="let item of campanhas" [value]="item.id">{{
                                            item.nomeCampanha }}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <div *ngIf="exigeComprovante" class="align-center">
                                    <div class="flex-column">
                                        <button mat-button (click)="fileUp.click()" type="button" color="primary">Upload
                                            de Comprovante &nbsp;
                                            <mat-icon matBadge="✔" [matBadgeHidden]="!hasComprovante"
                                                matBadgeColor="accent">cloud_upload</mat-icon>
                                        </button>
                                        <span class="upload-warning">Arquivo obrigatório</span>
                                    </div>
                                </div>

                                <div *ngIf="canDownloadComprovante" class="align-center">
                                    <div class="flex-column">
                                        <button mat-button (click)="downloadComprovante()" type="button"
                                            color="primary">Download de Comprovante &nbsp;
                                            <mat-icon>arrow_downward</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="valorApostila" class="grid grid--auto-fill">
                                <div class="align-center prl-1-5 noselect">
                                    <mat-slide-toggle formControlName="incluirApostila" color="primary">Incluir apostila
                                        no valor de {{ valorApostila | currency }}</mat-slide-toggle>
                                </div>
                            </div>
                        </form>
                        <div *ngIf="hasDadosSelecionados">
                            <title-line title="Característica do plano"></title-line>
                            <app-matricula-caracteristicas-plano [incluirApostila]="form.get('incluirApostila').value"
                                (onEfetuandoPagamento)="onEfetuandoPagamento($event)"></app-matricula-caracteristicas-plano>
                        </div>
                        <div *ngIf="hasDadosCampanha">
                            <title-line title="Bolsa / Convênio"></title-line>
                            <app-matricula-detalhe-campanha></app-matricula-detalhe-campanha>
                        </div>
                    </div>

                    <div *ngIf="false">
                        <title-line title="Detalhes do Pagamento"></title-line>
                        <app-matricula-detalhes-pagamento></app-matricula-detalhes-pagamento>
                    </div>
                </ng-container>
                <div *ngIf="hasMatricula">
                    <title-line title="Painel de Pagamento"></title-line>
                    <app-matricula-painel-pagamento [financeiroCadastrado]="financeiroCadastrado"
                        (onEfetuadoAcao)="ngOnInit()"
                        (loadingGerando)="loadingGerando($event)"></app-matricula-painel-pagamento>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
        </mat-card-actions>
    </mat-card>
</div>

<ng-template #modalTemplate>
    <h1 mat-dialog-title>Confirmação</h1>
    <div mat-dialog-content>{{ modalData }}</div>
    <div mat-dialog-actions>
        <button mat-button (click)="closeModal('cancelar')">Cancelar</button>
        <button mat-button color="primary" (click)="closeModal('ok')">OK</button>
    </div>
</ng-template>

<ng-template [ngIf]="modalOpen">
    <div class="modal-overlay" (click)="closeModal('cancelar')"></div>
    <div class="modal-container">
        <div class="modal-content">
            <ng-container
                *ngTemplateOutlet="modalTemplate; context: { $implicit: dialogRef, data: 'Confirma a data de promessa de pagamento?' }"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template>
    <router-outlet></router-outlet>
</ng-template>

<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>

<input #fileUp class="file-upload" type="file" (change)="loadFile($event)">
<input #contrato class="file-upload" type="file" (change)="uploadContrato($event)">